import { get, post } from './http'

export const ChangePwdSendSMS = p => get('Account/ChangePwdSendSMS', p);
export const GetFacadeInfo = p => get('Account/GetFacadeInfo', p);
export const Detail = p => get('Account/Detail', p); 
export const GetFacadeEnergyType = p => get('Account/GetFacadeEnergyType', p); 
export const MessageInfo = p => get('Account/MessageInfo', p);
export const GetSurplus = p => get('Account/GetSurplus', p);
export const UserInfo = p => get('Account/UserInfo', p);
export const BindingPhone = p => get('Account/BindingPhone', p);
export const Unbound = p => get('Account/Unbound', p);
export const GetFacadeList = p => get('Account/GetFacadeList', p);
export const PayOrder_Add = p => post('Account/PayOrder_Add', p);
export const PublicPay = p => get('WeChatPay/PublicPay', p);



// WEBPACK FOOTER //
// ./src/request/api.js